import { Target, Eye, Award, Users } from "lucide-react";
import { Card } from "@/components/ui/card";

const About = () => {
  const values = [
    {
      icon: Target,
      title: "Missão",
      description: "Desenvolver soluções tecnológicas inovadoras que transformem desafios em oportunidades de crescimento para nossos clientes."
    },
    {
      icon: Eye,
      title: "Visão",
      description: "Ser referência nacional em desenvolvimento de sistemas inteligentes, reconhecida pela excelência técnica e atendimento personalizado."
    },
    {
      icon: Award,
      title: "Valores",
      description: "Inovação, transparência, compromisso com qualidade e foco em resultados que impactam positivamente nossos clientes."
    }
  ];

  const differentials = [
    { icon: Users, text: "Atendimento personalizado e próximo" },
    { icon: Target, text: "Foco em resultados mensuráveis" },
    { icon: Award, text: "Tecnologias modernas e seguras" },
    { icon: Eye, text: "Transparência em todas as etapas" }
  ];

  return (
    <section id="about" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Sobre a <span className="text-primary">Digital Ideia</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Somos especialistas em transformar ideias em soluções digitais que geram valor real para empresas de todos os portes.
          </p>
        </div>

        {/* Nossa História */}
        <div className="mb-16 max-w-4xl mx-auto">
          <Card className="p-8 card-shadow">
            <h3 className="text-2xl font-bold mb-4">Nossa História</h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              A Digital Ideia nasceu da paixão por tecnologia e do desejo de tornar soluções digitais acessíveis 
              a empresas que buscam inovação e crescimento. Com anos de experiência no mercado, nossa equipe se 
              dedica a criar sistemas personalizados que atendem às necessidades específicas de cada cliente.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Combinamos expertise técnica com visão de negócio para entregar projetos que não apenas funcionam, 
              mas que transformam processos, aumentam produtividade e abrem novas oportunidades.
            </p>
          </Card>
        </div>

        {/* Missão, Visão e Valores */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {values.map((item, index) => (
            <Card 
              key={index} 
              className="p-6 hover:shadow-lg transition-shadow card-shadow group hover:border-primary/50"
            >
              <div className="w-14 h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <item.icon className="text-primary" size={28} />
              </div>
              <h3 className="text-xl font-bold mb-3">{item.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{item.description}</p>
            </Card>
          ))}
        </div>

        {/* Diferenciais */}
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-8">Nossos Diferenciais</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {differentials.map((item, index) => (
              <Card 
                key={index}
                className="p-6 flex items-start gap-4 hover:border-primary/50 transition-colors card-shadow"
              >
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <item.icon className="text-primary" size={24} />
                </div>
                <p className="font-medium pt-2">{item.text}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
